import moment from 'moment-timezone';

export const formatDate = (date) => {
    if (!date) return '';
    return moment.tz(date, 'America/Chicago').format('MM/DD/YYYY');
};
